import TaskHeader from "components/task/header/TaskHeader";
import { Box } from "@mui/joy";
import MyThoughtMapContent from "./MyThoughtMapContent";
import NoticeBannerStatic from "../../common/NoticeBannerStatic";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../../recoil/userAtom";

export default function MyThoughtMap({
  showPaymentModule,
}: {
  showPaymentModule: boolean;
}) {
  const user = useRecoilValue(userAtom);

  return (
    <>
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 100,
        }}
      >
        <TaskHeader taskKey={"thoughtmap"} />
        {user?.role === "patient" && (
          <NoticeBannerStatic
            message={"프로그램이 진행되며 자동으로 완성됩니다."}
            type={"thoughtMap"}
          />
        )}
      </Box>

      <div className="w-full h-full overflow-x-hidden">
        <MyThoughtMapContent />
      </div>
    </>
  );
}
